/**
 * Pure helper backing the "live backend" warning banner — copied verbatim from
 * `apps/admin-web/src/lib/environmentBanner.ts` (docs/325/337). This app has exactly ONE backend
 * URL today (`VITE_BACKEND_URL`, the production Worker — see `.env.example`), and a future
 * `scripts/deploy-admin-web-mantis.sh` would deploy it to a Cloudflare Pages **preview** branch by
 * default. A preview deploy still talks to the SAME production Worker/database — there is no
 * separate staging backend — so every mutation performed against a preview build (set a real
 * password, permanently delete a real account, …) is a REAL mutation. Rather than silently
 * trusting "this is a preview" to mean "this is safe," show an unmistakable banner whenever the
 * configured backend does not look like a local dev server.
 */
export function isLikelyProductionBackend(backendUrl: string | null): boolean {
  if (!backendUrl) return false;
  try {
    const host = new URL(backendUrl).hostname;
    return !(host === "localhost" || host === "127.0.0.1" || host.endsWith(".local"));
  } catch {
    // Not a parseable URL — treat as non-production rather than false-alarm.
    return false;
  }
}
